import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  Button,
} from '@pisaka/ui';
import { useModal } from '../../../../hooks/useModal';
import { PAYMENT_MODAL_NAME } from '../../../../constants/modalNamesConstants';
import {
  useCheckPayStatusCryptoFont, usePayCryptoFont, usePayFont, useUpdateFont, useGetFonts
} from '../font/useFonts';
import { AppStateTypes } from '../../../../store/appStateTypes';
import { socket } from '../../../../helpers/socket';

const PaymentModalContainer: FC = () => {
  const { isOpenModal, onCloseModal, payload } = useModal(PAYMENT_MODAL_NAME);

  const fontCreator = useSelector((state: AppStateTypes) => state.fontCreator);

  const { fontId } = payload;

  const currentFont = fontCreator.find((font) => Number(font.fontId) === Number(fontId));

  const { isLoadingUpdateFont, updateFont } = useUpdateFont();
  const { isLoadingPayFont, payFont } = usePayFont();
  const { isLoadingPayCryptoFont, payCryptoFont } = usePayCryptoFont();
  const { isCheckPayStatusCryptoFont, checkPayStatusCryptoFont } = useCheckPayStatusCryptoFont();
  const { loadingFonts } = useGetFonts();

  const isLoadingRub = isLoadingPayFont || isLoadingUpdateFont;
  const isLoadingCrypto = isLoadingPayCryptoFont || isCheckPayStatusCryptoFont;

  const onPayRub = async () => {
    const { paymentConfirmationToken, status, paymentId } = await payFont(fontId) || {};

    if (paymentConfirmationToken && paymentId) {
      const handlePaymentSuccess = async () => {
        await loadingFonts();
        onCloseModal();
        socket.off(`payment:${paymentId}`, handlePaymentSuccess);
      };

      socket.on(`payment:${paymentId}`, handlePaymentSuccess);

      // @ts-ignore
      const checkout = new window.YooMoneyCheckoutWidget({
        confirmation_token: paymentConfirmationToken,
        customization: {
          modal: true
        },
        error_callback() {}
      });

      checkout.render();

      checkout.on('success', () => {
        checkout.destroy();
      });

      checkout.on('fail', () => {
        socket.off(`payment:${paymentId}`, handlePaymentSuccess);
        checkout.destroy();
      });
    }

    if (status === 'succeeded') {
      await loadingFonts();
      onCloseModal();
    }
  };

  const onPayCrypto = async () => {
    if (currentFont?.orderId) {
      const { statusInvoice } = await checkPayStatusCryptoFont(currentFont?.orderId) || {};

      if (statusInvoice === 'created') {
        window.location.href = `https://pay.cryptocloud.plus/${currentFont?.orderId}`;
      }
    } else {
      const { status, payUrl, invoiceId } = await payCryptoFont(fontId) || {};

      if (status === 'success') {
        await updateFont({
          fontId,
          orderId: invoiceId,
        });

        if (payUrl) {
          window.location.href = payUrl;
        }
      }
    }
  };

  return (
    <Dialog open={isOpenModal} onOpenChange={(open) => !open && onCloseModal()}>
      <DialogContent className="w-[90vw] max-w-lg">
        <DialogHeader>
          <DialogTitle>Купить шрифт</DialogTitle>
        </DialogHeader>
        <div className="flex items-stretch gap-4 mt-2">
          <div className="flex-1 border rounded-lg p-4 space-y-3">
            <div className="font-semibold text-sm">Оплата шрифта с карты российского банка:</div>
            <Button
              size="sm"
              onClick={onPayRub}
              disabled={isLoadingRub}
              className="bg-gradient-accent hover:bg-accent shadow-accent text-primary-foreground"
            >
              {isLoadingRub ? (
                <span className="flex items-center gap-2">
                  <span className="h-3 w-3 animate-spin rounded-full border-2 border-current border-t-transparent" />
                  Купить за 199₽
                </span>
              ) : (
                'Купить за 199₽'
              )}
            </Button>
          </div>
          <div className="flex-1 border rounded-lg p-4 space-y-3">
            <div className="font-semibold text-sm">Оплата шрифта с помощью криптовалюты:</div>
            <Button
              size="sm"
              variant="outline"
              onClick={onPayCrypto}
              disabled={isLoadingCrypto}
            >
              {isLoadingCrypto ? (
                <span className="flex items-center gap-2">
                  <span className="h-3 w-3 animate-spin rounded-full border-2 border-current border-t-transparent" />
                  Купить шрифт за $2.59
                </span>
              ) : (
                'Купить шрифт за $2.59'
              )}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default PaymentModalContainer;
